<mat-form-field [formGroup]="form" appearance="standard" [floatLabel]="placeholder ? 'always' : 'auto'">
    <mat-label>{{label}}</mat-label>
    <input type="number" matInput [formControlName]="inputName" [placeholder]="placeholder" [required]="required"
        [min]="min" [max]="max" [errorStateMatcher]="matcher" [ngClass]="{'invalid': input.invalid }" autocomplete="off" (blur)="emitBlurEvent($event)">
    <mat-error *ngIf="input.hasError('required')">Mező kitöltése kötelező!</mat-error>
    <mat-error *ngIf="input.hasError('min')">{{input.errors?.message || minErrorText}}</mat-error>
    <mat-error *ngIf="input.hasError('max')">{{input.errors?.message}}</mat-error>
</mat-form-field>